export const determineAdditionalText = ({
  startDate,
  endDate,
  termValue,
  termUnit,
  translations,
}: {
  startDate: string;
  endDate: string;
  termValue: string;
  termUnit: string;
  translations: Record<string, string>;
}) => {
  return `${startDate} - ${endDate} ${translations['becomeamember.floatingreceipt.every']} ${termValue} ${termUnit}`;
};
